export default {
  NOT_SCHEDULED: {
    Title: 'Not Scheduled',
    Color: '#FFFFFF',
    ColorText: '#7C7C7C',
    ColorBorder: '#D8D3CC',
  },
  SCHEDULED: {
    Title: 'Scheduled',
    Color: '#FFFFFF',
    ColorText: '#5A95CC',
    ColorBorder: '#76AADA',
  },
  COMPLETED: {
    Title: 'Completed',
    Color: '#FFFFFF',
    ColorText: '#4AA253',
    ColorBorder: '#3FB14E',
  },
  NO_SHOW: {
    Title: 'No Show',
    Color: '#FFFFFF',
    ColorText: '#D15252',
    ColorBorder: '#DA7955',
  },
  RESCHEDULED: {
    Title: 'Rescheduled',
    Color: '#FFFFFF',
    ColorText: '#3A3684',
    ColorBorder: '#AEAAE7',
  },
  CANCELLED: {
    Title: 'Cancelled',
    Color: '#FFFFFF',
    ColorText: '#D15252',
    ColorBorder: '#D15252',
  },
};
